import { GraphPoints } from 'api/queries/getProjectStatusScoreCards.query';

export type Data = {
    name: string;
    graphPoints: GraphPoints[];
};

const getDataReadyForSerialize = (data: Data[]) => {
    if (data === undefined || data.length === 0) {
        return { graphPoints: [], name: '' };
    } else {
        return data[0];
    }
};

export const getCardGraphSeriesAndOptions = (
    data: Data[],
    themeStatus: boolean,
    xaxisTitle: string,
    yaxisTitle: string,
    yAxisMaxValue: number | undefined,
    serializeData: ({
        data,
        themeStatus,
    }: {
        data: Data;
        themeStatus: boolean;
    }) => ApexAxisChartSeries | ApexNonAxisChartSeries | undefined,
    serializeOptions: ({
        data,
        themeStatus,
        xaxisTitle,
        yaxisTitle,
        yAxisMaxValue,
    }: {
        data: Data;
        themeStatus: boolean;
        xaxisTitle: string;
        yaxisTitle: string;
        yAxisMaxValue: number | undefined;
    }) => ApexCharts.ApexOptions,
) => {
    const serializeReadyData = getDataReadyForSerialize(data);
    const series = serializeData({ data: serializeReadyData, themeStatus });
    const options = serializeOptions({
        data: serializeReadyData,
        themeStatus,
        xaxisTitle,
        yaxisTitle,
        yAxisMaxValue,
    });

    return {
        series,
        options,
    };
};
